import styled from "styled-components";

// Shared status-line + map-controls chrome for full-screen Leaflet map
// pages (home, pinmonkey lobby). `MapControls`'s `$dock` prop selects which
// corner/edge it docks to, since the two pages place it differently to avoid
// colliding with their own page-specific chrome (home's menu button vs.
// lobby's bottom-left CharacterPanel).
export const StatusLine = styled.div`
  position: absolute;
  top: 1.25rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  font-family: "Silkscreen", monospace;
  font-size: 0.68rem;
  color: ${({ theme }) => theme.colors("foreground", 0.45)};
  pointer-events: none;
  white-space: nowrap;
  text-align: center;
  @media (max-width: 480px) {
    top: 0.75rem;
  }
`;

export const MapControls = styled.div`
  position: absolute;
  right: 1.25rem;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  ${({ $dock = "top" }) =>
    $dock === "bottom"
      ? `
    bottom: 2rem;
  `
      : `
    top: 1.25rem;
  `}
  @media (max-width: 480px) {
    right: 0.75rem;
    ${({ $dock = "top" }) =>
      $dock === "bottom"
        ? `
      top: 4rem;
      bottom: auto;
    `
        : `
      top: 0.75rem;
    `}
  }
`;
